import { selectError } from '../../state/slices/slice-error';
import eventQueue from '../queue';
function attachEventListeners() {
    // Exit event
    eventQueue.on('exit', function (_a) {
        var state = _a.state, fireClientEvent = _a.fireClientEvent;
        var error = selectError(state);
        if (error)
            fireClientEvent('exit', { error: error });
        else
            fireClientEvent('exit', {});
    });
}
attachEventListeners();
